import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class UserPostAddService {
  constructor(private http: HttpClient) {}
  // ton apis
  getUserPosts(data:any) {
    return this.http.post(environment.apiUrl + "load/search", data);
  }
  delete(id:any) {
    return this.http.delete(environment.apiUrl + `load/delete/${id}`);
  }
}
